import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { EmailValidationService } from "../../services/email-validation.service";
import { UserInfoService } from "../../services/user-info.service";
import { FormsModule } from "@angular/forms";
import { NgClass, UpperCasePipe } from "@angular/common";
import { Subject } from "rxjs";
import { RouterModule } from "@angular/router";
import { EmailValidationResponse } from "../../models/email-validation-response.model";
import { TranslateModule, TranslatePipe } from "@ngx-translate/core";
import { DeviceDetectService } from "../../services/device-detect.service";
import { appearSlowlyAnimation } from "../../features/cookie-modal/cookie-modal-animation";
import { ContactInfoService } from "../../services/contact-info.service";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-email-validation-modal",
  templateUrl: "./email-validation-modal.component.html",
  animations: [appearSlowlyAnimation],
  imports: [
    FormsModule,
    RouterModule,
    TranslatePipe,
    NgClass,
    TranslateModule,
    UpperCasePipe,
    UpperCasePipe
],
  styleUrl: "./email-validation-modal.component.css",
})
export class EmailValidationModalComponent implements OnInit, OnDestroy {
  step: "intro" | "codeSent" | "success" = "intro";
  code: string = "";
  errorMessage: string = "";
  validationEmail: string = "";
  loading: boolean = false;
  personalCode: string;
  isMobile: boolean;
  private destroy$ = new Subject<void>();

  constructor(
    private dialogRef: MatDialogRef<EmailValidationModalComponent>,
    private emailValidationService: EmailValidationService,
    private userInfoService: UserInfoService,
    private deviceDetectService: DeviceDetectService,
    private contactInfoService: ContactInfoService,
  ) {
  }

  ngOnInit() {
    this.isMobile = this.deviceDetectService.isMobile;
    this.userInfoService.sessionContext$
      .pipe(takeUntil(this.destroy$))
      .subscribe(ctx => {
        if (ctx) {
          this.personalCode = ctx.personalCode ?? "";
        }
      });
  }

  sendCode() {
    this.errorMessage = "";
    this.loading = true;
    this.emailValidationService.requestValidation(this.personalCode, sessionStorage.getItem("lang"))
      .then((response: EmailValidationResponse | null) => {
        this.loading = false;
        if (response) {
          if (response.acknowledgment.responseCode === "ACC") {
            this.validationEmail = response.message;
            this.step = "codeSent";
          } else {
            if (response.acknowledgment.responseCode === "ERR" && response.acknowledgment.acknowledgmentDetailList &&
              response.acknowledgment.acknowledgmentDetailList.length > 0) {
              console.log(response.acknowledgment.acknowledgmentDetailList[0].messageCode);
              this.errorMessage = "emailValidation.error." + response.acknowledgment.acknowledgmentDetailList[0].messageCode;
            } else {
              this.errorMessage = "emailValidation.error.failSendCode";
            }
          }
        } else {
          this.errorMessage = "emailValidation.error.noRespondFromServer";
        }
      })
      .catch((err) => {
        this.loading = false;
        this.errorMessage = err?.error?.message;
      });
  }

  validateCode() {
    this.errorMessage = "";
    this.loading = true;
    this.emailValidationService.verifyCode(this.personalCode, this.code)
      .then((response: EmailValidationResponse | null) => {
        this.loading = false;
        if (response) {
          if (response.acknowledgment.responseCode === "ACC") {
            this.step = "success";
            this.contactInfoService.getContactInfo();
          } else {
            if (response.acknowledgment.responseCode === "ERR" && response.acknowledgment.acknowledgmentDetailList &&
              response.acknowledgment.acknowledgmentDetailList.length > 0) {
              this.errorMessage = "emailValidation.error." + response.acknowledgment.acknowledgmentDetailList[0].messageCode;
            } else {
              this.errorMessage = "emailValidation.error.failValidation";
            }
          }
        } else {
          this.errorMessage = "emailValidation.error.noRespondFromServer";
        }
      })
      .catch((err) => {
        this.loading = false;
        this.errorMessage = err?.error?.message;
      });
  }

  closeModal() {
    this.dialogRef.close(true);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
